var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import dayjs from 'dayjs';
import { useMe } from '@/atoms/Auth';
import useAppComponents from '@/hooks/useAppComponents';
import ToastUtils from './ToastUtils';
// 정보통신망법: 동의·철회 시 일시와 결과를 통지한다. 문구는 이 함수 한 곳에서만 만든다.
export function marketingPushAgreementResultMessage(isAgreed) {
    return `${dayjs().format('YYYY.MM.DD')} 계단뿌셔클럽 마케팅 정보 수신${isAgreed ? '에 동의했어요' : '을 거부했어요'}`;
}
// 서버 저장 → 유저 정보 갱신 → 결과 통지 토스트. 성공 여부를 반환하고, 실패 시 에러 토스트를 띄운다.
export function useUpdateMarketingPushAgreement() {
    const { api } = useAppComponents();
    const { setUserInfo } = useMe();
    return (isAgreed) => __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield api.updateMarketingPushAgreementPost({ isAgreed });
            yield setUserInfo(res.data.user);
            ToastUtils.show(marketingPushAgreementResultMessage(isAgreed));
            return true;
        }
        catch (e) {
            ToastUtils.showOnApiError(e);
            return false;
        }
    });
}
